// GA4 / Google Ads conversion tracking
// gtag is loaded globally via index.html — this module provides a type-safe wrapper

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

type GtagParams = Record<string, string | number | boolean | null | undefined>;

export function trackEvent(eventName: string, params?: GtagParams): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params || {});
  }
}